var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jade-box",
    { staticClass: "eu-mt_5 eu-mb_3", attrs: { hasPadding: "" } },
    [
      _c(
        "jade-text",
        {
          staticClass: "eu-mb_2",
          attrs: {
            color: "neutral",
            variant: "text-large",
            weight: "semibold",
          },
        },
        [_vm._v(_vm._s(_vm.$t("stepStatusTracker.title")) + " ")]
      ),
      _c(
        "jade-text",
        {
          staticClass: "eu-mb_4",
          attrs: { color: "medium", variant: "text-medium", weight: "regular" },
        },
        [_vm._v(_vm._s(_vm.$t("stepStatusTracker.description")) + " ")]
      ),
      _c("jade-status-tracker", { attrs: { items: _vm.items } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }